// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-button {\n  min-height: 250px;\n  height: 250px;\n  min-width: 45px !important;\n  max-width: 45px;\n  opacity: 0.5;\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n.nav-button:hover {\n  opacity: 1;\n}\n.transparent {\n  background-color: rgba(0, 0, 0, 0) !important;\n}", ""]);
// Exports
module.exports = exports;
